import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CaptureImageData} from '../../models/captureImage-model';
import {LocalStorageService} from '../../../local-storage.service';
import {SwissSettingsService} from '../../../services/swiss-settings.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {tap} from 'rxjs';

@Component({
    selector: 'app-edit-image-details',
    templateUrl: './edit-image-details.component.html',
    styleUrls: ['./edit-image-details.component.scss']
})
export class EditImageDetailsComponent implements OnInit {
    public imageEditForm = new UntypedFormGroup({
        fileName: new UntypedFormControl(''),
        description: new UntypedFormControl(''),
    });

    constructor(
        public dialogRef: MatDialogRef<EditImageDetailsComponent>,
        @Inject(MAT_DIALOG_DATA) public image: CaptureImageData,
        private settingsService: SwissSettingsService
    ) {
    }

    ngOnInit(): void {
        this.imageEditForm.controls.fileName.disable();
        this.imageEditForm.setValue({
            fileName: this.image.fileName,
            description: this.image.description,
        });
        this.settingsService.getWebConfig$().pipe(
            takeUntilDestroyed(),
            tap(config => {
                if (config.debugMode) {
                    this.imageEditForm.controls.fileName.enable();
                }
            })
        ).subscribe();
    }

    next(): void {
        this.image.fileName = this.imageEditForm.controls.fileName.value;
        this.image.description = this.imageEditForm.controls.description.value;
        this.dialogRef.close(this.image);
    }

    closeDialog(): void {
        this.dialogRef.close();
    }
}
